import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { StoreListResponse } from '../../common/types/types'

interface StoreListState {
  data: StoreListResponse
  forceStores: number[]  // 👈 массив выбранных точек
}

const initialState: StoreListState = {
  data: {
    data: [],
    total: 0,
  },
  forceStores: [],
}

export const storeListSlice = createSlice({
  name: 'store-list',
  initialState,
  reducers: {
    setStoreList: (state, action: PayloadAction<StoreListResponse>) => {
      state.data = { ...action.payload }
    },
    setForceStores: (state, action: PayloadAction<number[]>) => {
      state.forceStores = action.payload
    },
    addForceStore: (state, action: PayloadAction<number>) => {
      if (!state.forceStores.includes(action.payload)) {
        state.forceStores.push(action.payload)
      }
    },
    removeForceStore: (state, action: PayloadAction<number>) => {
      state.forceStores = state.forceStores.filter(id => id !== action.payload)
    },
  },
})

export const { setStoreList, setForceStores, addForceStore, removeForceStore } = storeListSlice.actions

export const selectStoreList = (state: RootState) => state.storeList.data.data
export const selectForceStores = (state: RootState) => state.storeList.forceStores

export const selectStoreItem = (id: number) =>
  createSelector([selectStoreList], (stores) => stores.find((el) => el.id === id))

export default storeListSlice.reducer